__turbopack_context__.v({
  "button": "CollapsableSection-module-scss-module__FwPSnG__button",
});
